<template>
    <div class="popup-menu-wrapper" :style="style" v-show="show">
        <div
            class="popup-menu"
            :class="{ 'menu-selected': curValue === menu.value }"
            v-for="(menu, idx) in menuItems"
            :key="idx"
            :title="menu.label"
            @click="clickHandler(menu)"
            @mouseover="menuOn(menu)"
            @mouseleave="menuLeave(menu)"
        >
            {{ menu.label }}
            <Icon class="popup-right-icon" :width="14" :height="14" :iconUrl="menu.iconRight" :bgPosition="menu.position" v-if="menu.iconRight" />
        </div>
    </div>
</template>

<script>
/**
 * emit menuChange
 * menus=[{label, value, icon, iconRight, bgPosition, hoverPosition},...], position={direct=up||down, left=int, topOrBotton=int}, isShow=true||false
 */
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "PopupMenu",
    props: ["menus", "position", "isShow", "current", "noMemory"],
    components: {
        Icon
    },
    data() {
        return {
            show: this.isShow,
            curValue: this.current,
            direct: (this.position && this.position.direct) || "",
            left: (this.position && this.position.left) || 0,
            topOrBottom: (this.position && this.position.topOrBottom) || 30,
            menuItems: []
        };
    },
    computed: {
        style() {
            return this.getStyle();
        }
    },
    watch: {
        isShow(newVal) {
            this.show = newVal;
        },
        current() {
            this.curValue = this.current;
        },
        menus(newVal) {
            this.setMenuItems(newVal);
        }
    },
    methods: {
        clickHandler(menu) {
            if (!this.noMemory && this.curValue === menu.value) {
                this.$emit("menuHide");
                return;
            }

            this.curValue = menu.value;
            this.$emit("menuChange", menu);
        },
        getStyle() {
            let style = {
                left: this.left + "px"
            };
            style[this.direct == "up" ? "bottom" : "top"] = this.topOrBottom + "px";

            return style;
        },
        setMenuItems(menus) {
            this.menuItems.splice(0);
            this.menuItems.push(
                ...menus.map(function(menu) {
                    return {
                        label: menu.label,
                        value: menu.value,
                        icon: menu.icon,
                        iconRight: menu.iconRight,
                        bgPosition: menu.bgPosition,
                        position: menu.bgPosition,
                        hoverPosition: menu.hoverPosition
                    };
                })
            );
        },
        menuOn(menu) {
            if (!menu.iconRight) {
                return;
            }

            menu.position = menu.hoverPosition;
            let idx = this.menuItems.indexOf(menu);
            if (idx > -1) {
                this.menuItems.splice(idx, 1, Object.assign({}, menu));
            }
        },
        menuLeave(menu) {
            if (!menu.iconRight) {
                return;
            }

            menu.position = menu.bgPosition;
            let idx = this.menuItems.indexOf(menu);
            if (idx > -1) {
                this.menuItems.splice(idx, 1, Object.assign({}, menu));
            }
        }
    },
    mounted() {
        this.setMenuItems(this.menus);
    }
};
</script>

<style lang="less" scoped>
.popup-menu-wrapper {
    position: absolute;
    min-width: 120px;
    background: #fff;
    border-radius: 4px;
    z-index: 1;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

    .popup-menu {
        text-align: center;
        position: relative;
        padding: 8px 5px;
        cursor: pointer;

        &:hover {
            background: rgba(217, 235, 246, 0.7);
            color: #2ec2ff;
        }

        .popup-right-icon {
            margin-left: 2px;
        }
    }

    .menu-selected {
        background: rgba(217, 235, 246, 0.7);
        color: #2ec2ff;
    }
}

.search-input {
    .select-div {
        top: 42px !important;
    }
}
</style>
